import { z } from 'zod';

/** Проверяет данные для формирования платежа по заказу */
export const createPaymentSchema = z.object({
    promoCodeNumber: z.string(),
    hasCustomService: z.boolean(),
    customServiceName: z.string(),
    customServicePrice: z.number()
        .nullable(),
    customServiceExecutorReward: z.number()
        .nullable(),
})
    .superRefine((values, context) => {
        if (!values.hasCustomService) return;

        if (!values.customServiceName.trim()) {
            context.addIssue({
                code: 'custom',
                path: ['customServiceName'],
                message: 'Введите наименование услуги',
            });
        }

        if (values.customServicePrice === null || values.customServicePrice < 0) {
            context.addIssue({
                code: 'custom',
                path: ['customServicePrice'],
                message: 'Укажите цену не меньше нуля',
            });
        }

        if (values.customServiceExecutorReward === null || values.customServiceExecutorReward < 0) {
            context.addIssue({
                code: 'custom',
                path: ['customServiceExecutorReward'],
                message: 'Укажите вознаграждение не меньше нуля',
            });
        }
    });

export type CreatePaymentFormValues = z.infer<typeof createPaymentSchema>;

export const CREATE_PAYMENT_FORM_DEFAULTS: CreatePaymentFormValues = {
    promoCodeNumber: '',
    hasCustomService: false,
    customServiceName: '',
    customServicePrice: null,
    customServiceExecutorReward: null,
};
